import { render, staticRenderFns } from "./EtapasCounter.vue?vue&type=template&id=685f509c&scoped=true&"
import script from "./EtapasCounter.vue?vue&type=script&lang=js&"
export * from "./EtapasCounter.vue?vue&type=script&lang=js&"
import style0 from "./EtapasCounter.vue?vue&type=style&index=0&id=685f509c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f509c",
  null
  
)

export default component.exports